import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { DeviceSessionsService } from '@app/shared/services';

export const canActivateUserDevices: CanActivateFn = () => {
    const deviceSessionsService = inject(DeviceSessionsService);
    const router = inject(Router);

    return (
        deviceSessionsService.userDevices?.length > 0 ||
        deviceSessionsService.deviceSessions?.length > 0 ||
        router.createUrlTree(['/'])
    );
};
